import React from "react";
import { MdCheckCircle } from "react-icons/md";

const About = () => {
  const skills = [
    {
      id: 1,
      skill:
        "Developed full-stack applications using MERN stack, Spring Boot and Django",
    },
    {
      id: 2,
      skill:
        "Automation and orchestration tools such as Terraform, Jenkins, Ansible, and GitLab",
    },
    {
      id: 3,
      skill:
        "Containerization tools such as Docker and Kubernetes",
    },
    {
      id: 4,
      skill:
        "Successfully created and maintained automated (CI/CD) pipelines",
    },
    {
      id: 5,
      skill:
        "Developing and providing support apps in AWS, Azure, Google Cloud Platform (GCP)",
    },
    {
      id: 6,
      skill:
        "Monitoring tools such as Datadog, Prometheus, Grafana and Kibana",
    },
    {
      id: 7,
      skill:
        "Experience working on various DevOps technologies stack and tools like Kubernetes, Docker, Ansible, Prometheus, Grafana, AWS EKS, Jenkins, GIT, GitHub, GitLab, Terraform",
    },
    {
      id: 8,
      skill:
        "Ability to adapt to situations quickly with good analytical skills and quick learning",
    },
    {
      id: 9,
      skill:
        "Design and implement network security controls for AWS edge services and monitoring and alerting to address security events and threats",
    },
    {
      id: 10,
      skill:
        "Good understanding of infrastructure and cloud network TCP/UDP protocols, firewalls, DNS, WAF and Content Delivery",
    },
  ];
  return (
    <div
      name="about"
      className="w-full bg-gradient-to-b from-zinc-900 via-slate-950 to-gray-950 text-white py-6 md:py-8 lg:py-10 -mt-px"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8">
        {/* About Me Section */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
              About Me
            </h3>
          </div>
          
          {/* Modern Paragraph Layout */}
          <div className="max-w-3xl space-y-5">
            <p className="text-gray-200 text-base md:text-lg lg:text-xl leading-relaxed font-light tracking-wide">
              I am a passionate <span className="text-blue-400 font-semibold">Software Engineer</span> and <span className="text-cyan-400 font-semibold">DevOps Engineer</span> with 
              <span className="text-white font-bold"> six years</span> of experience in designing, implementing, and managing complex infrastructures.
            </p>
            
            <p className="text-gray-200 text-base md:text-lg lg:text-xl leading-relaxed font-light tracking-wide">
              I specialize in <span className="text-blue-400 font-semibold">automation</span>, <span className="text-blue-400 font-semibold">cloud architecture</span>, and 
              <span className="text-blue-400 font-semibold"> microservices development</span>. My expertise spans across multiple DevOps tools and cloud platforms including 
              <span className="text-orange-400 font-semibold"> AWS</span>, <span className="text-blue-400 font-semibold">Azure</span>, and <span className="text-blue-300 font-semibold">Google Cloud Platform</span>.
            </p>
            
            <p className="text-gray-200 text-base md:text-lg lg:text-xl leading-relaxed font-light tracking-wide">
              I excel at developing, automating, configuring, managing, and deploying <span className="text-white font-semibold">large-scale cloud-native applications</span> 
              that drive business value and operational efficiency.
            </p>
          </div>
        </div>

        {/* Skills Section */}
        <div className="mt-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
              Skills
            </h3>
          </div>
          
          <div className="relative">
            {/* Scrollable Container */}
            <div className="relative max-h-96 sm:max-h-none overflow-y-scroll sm:overflow-visible pr-3 sm:pr-0 custom-scrollbar-visible bg-gray-900/60 backdrop-blur-sm rounded-lg border border-gray-700/50 p-3 sm:p-4">
              {/* Top Fade Gradient - indicates scrollable content */}
              <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-gray-900/95 via-gray-900/80 to-transparent pointer-events-none z-10 sm:hidden rounded-t-lg"></div>
              
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 pt-2 sm:pt-0 pb-2 sm:pb-0">
                {skills.map(({ id, skill }) => (
                  <div
                    key={id}
                    className="group flex items-start gap-2 sm:gap-3 p-3 sm:p-4 rounded-lg bg-gray-800/50 hover:bg-gray-700/60 transition-all duration-300 border border-gray-600/40 hover:border-blue-500/50 backdrop-blur-sm"
                  >
                    <MdCheckCircle className="text-blue-500 mt-0.5 flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" size={20} />
                    <p className="text-gray-200 text-xs sm:text-sm md:text-base leading-relaxed font-light tracking-wide">
                      {skill}
                    </p>
                  </div>
                ))}
              </div>
              
              {/* Bottom Fade Gradient - indicates more content */}
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-gray-900/95 via-gray-900/80 to-transparent pointer-events-none z-10 sm:hidden rounded-b-lg"></div>
            </div>
            
            {/* Scroll Indicator Text - only on small screens */}
            <div className="text-center mt-3 sm:hidden">
              <p className="text-xs flex items-center justify-center gap-2">
                <span className="text-yellow-400 animate-bounce">↓</span>
                <span className="bg-gradient-to-r from-yellow-400 via-orange-400 to-amber-500 bg-clip-text text-transparent font-medium">
                  Scroll to see more skills
                </span>
                <span className="text-yellow-400 animate-bounce" style={{ animationDelay: '0.2s' }}>↓</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
